var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7723 32.1636C25.6089 32.1636 32.7723 25.0001 32.7723 16.1636C32.7723 7.32702 25.6089 0.163574 16.7723 0.163574C7.93578 0.163574 0.772339 7.32702 0.772339 16.1636C0.772339 25.0001 7.93578 32.1636 16.7723 32.1636Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8155 12.8289H17.808V14.3195C18.2391 13.4622 19.3445 12.6919 21.0051 12.6919C24.1886 12.6919 24.9444 14.3985 24.9444 17.5295V23.3284H21.7214V18.2426C21.7214 16.4595 21.2904 15.454 20.193 15.454C18.6709 15.454 18.0384 16.5377 18.0384 18.2418V23.3284H14.8155V12.8289ZM9.28898 23.1914H12.5119V12.6919H9.28898V23.1914ZM12.9736 9.26836C12.9737 9.53851 12.9201 9.80598 12.816 10.0552C12.7118 10.3045 12.5592 10.5306 12.3669 10.7203C11.9772 11.1075 11.4498 11.3243 10.9004 11.323C10.3521 11.3226 9.82585 11.1064 9.43562 10.7211C9.24403 10.5307 9.09189 10.3044 8.98791 10.0551C8.88394 9.80582 8.83018 9.53847 8.82971 9.26836C8.82971 8.72288 9.04726 8.20077 9.43643 7.81563C9.82631 7.42981 10.3527 7.2135 10.9013 7.21375C11.4508 7.21375 11.9777 7.43049 12.3669 7.81563C12.7552 8.20077 12.9736 8.72288 12.9736 9.26836Z",
    fill: "#7536FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.bb3aceedc8a2cb040b72977dde7e5f44.svg";
export { ForwardRef as ReactComponent };